import React from "react";
import CardDigitalImg from "../../assets/img/fmg/card-digital-home-forager-media-group.png";
import CardProductionsImg from "../../assets/img/fmg/card-productions-home-forager-media-group.png";
import CardPublishingImg from "../../assets/img/fmg/card-publishing-home-forager-media-group.png";
import CradVirtualImg from "../../assets/img/fmg/card-virtual-home-forager-media-group - copia.png";
import DivisionCard from "./DivisionCard";

export default function Divisions() {
  const divisions = [
    {
      title: "digital",
      img: CardDigitalImg,
      text: "Powered by innovative graphic designers, web developers, anddigital marketers, our digital division is ready to take your brand to the next level. Whether you need a new website, custom branding, or promotional help, our team is ready.",
      logo: require("../../assets/img/fmg/forager-digital.png"),
      styleLogo:"w-[71%] xl:w-10/12"
    },
    {
      title: "virtual",
      img: CradVirtualImg,
      text: "Powered by experienced virtual and augmented reality developers, our virtual division is ready to help you take advantage of this new technology. Whether you need a VR tour, an AR scavenger hunt, or virtual learning resources, our team is ready.",
      logo: require("../../assets/img/fmg/forager-virtual.png"),
      styleLogo:"w-[71%] xl:w-10/12"
    },
    {
      title: "productions",
      img: CardProductionsImg,
      text: "Powered by Powered by expert producers, editors, and audio engineers, our production division is ready to turn your storyboard into an amazing experience. Whether you need help with a podcast, a YouTube series, or promotional videos, our team is ready.",
      logo: require("../../assets/img/fmg/forager-productions.png"),
      styleLogo:"w-11/12 xl:w-full"
    },
    {
      title: "publishing",
      img: CardPublishingImg,
      text: "Powered by creative writers, eagle-eyed editors and publishing specialists, our publishing division is ready to turn your idea into a reality. Whether you need help with your online magazine, or getting your book ready for publishing, our team is ready.",
      logo: require("../../assets/img/fmg/forager-publishing.png"),
      styleLogo:"w-10/12 xl:w-full"
    },
  ];
  return (
    <section className="pt-56 pb-72 -mt-5 container mx-auto">
    <div className="grid grid-cols-4 gap-4">
        {divisions.map((ele, index) => (
          <DivisionCard
            key={index}
            img={ele.img}
            title={ele.title}
            text={ele.text}
            logo={ele.logo}
            styleLogo={ele.styleLogo}
          />
        ))}
      </div>
    </section>
  );
}
